import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import configureStore, { history } from './store';
import initialState from './store/initialState';
import { MyThemeProvider } from './context/ThemeContext';
import RootComponents from './components/RootComponents/RootComponents';
import Loader from './components/Loader/Loader';
import ErrorBoundary from './components/ErrorBoundary';
import Routes from './Routes';

const store = configureStore(initialState);

const Root = () => (
  <Provider store={store}>
    <MyThemeProvider>
      <ConnectedRouter history={history}>
        <React.Suspense fallback={<Loader />}>
          <ErrorBoundary>
            <RootComponents />
            <Routes />
          </ErrorBoundary>
        </React.Suspense>
      </ConnectedRouter>
    </MyThemeProvider>
  </Provider>
);

export default Root;
